export default class CRUDTableEntity {
    constructor(partitionKey = undefined, rowKey = undefined) {
        this.partitionKey = partitionKey;
        this.rowKey = rowKey;
    }
}
